var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor get-supsis-record-by-id" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "section",
        [
          _c("div", { staticClass: "editor-row-title" }, [_vm._v("Module")]),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.modules,
              idKey: "value",
              labelKey: "label",
              title: this.$t("message.selectModule"),
              icon: "filter_list",
            },
            model: {
              value: _vm.clone.module,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "module", $$v)
              },
              expression: "clone.module",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [_vm._v("ID")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Type Record ID",
                "show-attributes": true,
                "show-emoji": true,
                "max-character-count": 1024,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.id,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "id", $$v)
                },
                expression: "clone.id",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.clone.module === "formSubmission"
        ? _c(
            "section",
            [
              _c("div", { staticClass: "title" }, [_vm._v("Form")]),
              _vm._v(" "),
              _c("CustomPicker", {
                attrs: {
                  items: _vm.formsList,
                  idKey: "_id",
                  labelKey: "title",
                  title: this.$t("message.selectForm"),
                  icon: "text_snippet",
                },
                model: {
                  value: _vm.clone.formId,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "formId", $$v)
                  },
                  expression: "clone.formId",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }